<template>
  <div class="variation-sub-row">
    <div class="variation-sub-row__sku" v-if="!hideSKU">
      <div class="shop-table__line">
        {{ variation.sku | emptyDash }}
      </div>
    </div>
    <div
      v-for="attributeTaxonomy in displayedAttributeTaxonomies"
      :key="`variation_attribute_${attributeTaxonomy}`"
    >
      <div class="shop-table__line">
        {{ getAttributeValue(variation.meta_fields, attributeTaxonomy) | emptyDash }}
      </div>
    </div>
    <div class="variation-sub-row__price">
      <Price
        :regularPrice="Number(variation.regular_price)"
        :salePrice="Number(variation.sale_price)"
      />
    </div>
    <div class="variation-sub-row__other" v-if="showOtherInfo">
      <div class="shop-table__line">
        {{ variation.excerpt }}
      </div>
    </div>

    <div class="variation-sub-row__wishlist">
      <Wishlist :productId="variation.id" />
    </div>

    <div class="variation-sub-row__cart">
      <AddToCart
        :name="name"
        :sku="variation.sku"
        :permalink="variation.permalink"
        :id="variation.id"
        :minQuantity="parseFloat(variation.get_min_purchase_quantity)"
        :maxQuantity="variation.get_max_purchase_quantity === '' ? -1 : parseFloat(variation.get_max_purchase_quantity)"
        :soldIndividually="variation.sold_individually"
        :measurementUnit="variation.measurement_unit != undefined ? variation.measurement_unit : ''"
        :buyingStep="variation.buying_step != undefined ? variation.buying_step : 1"
        :stockStatus="variation.stock_status"
      />
    </div>
  </div>
</template>

<script>
import Price from '@/layouts/general-ui/Price.vue';
import AddToCart from '@/layouts/general-ui/AddToCart.vue';
import Wishlist from "@/layouts/general-ui/Wishlist.vue";

export default {
  name: 'VariationSubRow',
  components: {
    Price,
    AddToCart,
    Wishlist
  },
  props: {
    variation: Object,
    showOtherInfo: Boolean,
    displayedAttributeTaxonomies: Array,
    hideSKU: Boolean,
    name: String
  },
  filters: {
    emptyDash(value) {
      if (!value) return '-';
      return value;
    },
  },
  methods: {
    getAttributeValue: function(attributes, attributeTaxonomy){
      if(attributes == undefined || Object.keys(attributes).length === 0) return;

      const foundKey = Object.keys(attributes).find(key => key == 'attribute_' + attributeTaxonomy);
      if(foundKey == undefined) return '';

      return attributes[foundKey];
    }
  }
};
</script>

<style lang="scss" scoped>
.variation-sub-row {
  display: grid;
  grid-template-columns: 0.2fr 0.1fr 0.1fr 0.1fr 0.1fr 0.4fr 12rem;
  gap: 2rem;

  div {
    word-break: break-all;
  }
}
</style>
